import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiNewsletterSectionDTO,
  NewsletterSectionDTO,
} from "@lib/strapi/dtos/components/sections/newsletterSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export class NewsletterSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiNewsletterSectionDTO,
  ): Promise<NewsletterSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new NewsletterSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.heading = strapiData.heading;
    dto.intro = await parseStrapiContent(strapiData.intro);
    dto.successMessage = await parseStrapiContent(strapiData.successMessage);
    return dto;
  }
}
